var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeEF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.333,
    cy: 41.167,
    r: 6.333,
    fill: "#4A4A4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.667,
    cy: 41.167,
    r: 6.333,
    fill: "#4A4A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 31.667a6.34 6.34 0 006.333-6.334A6.34 6.34 0 0038 19a6.34 6.34 0 00-6.333 6.333A6.34 6.34 0 0038 31.667zm0-11.22a4.892 4.892 0 014.887 4.886A4.892 4.892 0 0138 30.221a4.892 4.892 0 01-4.887-4.888A4.892 4.892 0 0138 20.446z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 66.5c15.74 0 28.5-12.76 28.5-28.5S53.74 9.5 38 9.5 9.5 22.26 9.5 38 22.26 66.5 38 66.5zm0-1.9c14.69 0 26.6-11.91 26.6-26.6 0-14.69-11.91-26.6-26.6-26.6-14.69 0-26.6 11.91-26.6 26.6 0 14.69 11.91 26.6 26.6 26.6z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/Type_E_F.26412b71.svg";
export { SvgTypeEF as ReactComponent };